import React from 'react'
import image from '../../../assets/homepage_pro2.png'
const BannerBoxTwo = () => {
    return (
        <>
            <div className="box1 bg-sky">
                <div className="bx-txt">
                    <h4>Beauty</h4>
                    <h3>
                        20% Off or more <span>Beauty Products</span>
                    </h3>
                    <a href="#" className="btn-buy">
                        BUY NOW
                    </a>
                </div>
                <div className="bx-img">
                    <img className="img-fluid" src={image} alt="" />
                </div>
            </div>

        </>
    )
}

export default BannerBoxTwo